module.exports = __webpack_public_path__ + "videos/video-footer.52e9718.mp4";